import { getSnowplowEventPayload, logAnalyticsEvent } from '../analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from '../analytics.const';

const {
	MARKETPLACE: { DELETE_SAVED_SEARCH },
} = ANALYTICS_CATEGORIES;

export const triggerSavedSearchDeleteButtonClickEvent = (id?: string | number): void => {
	const eventPayload = getSnowplowEventPayload({
		category: DELETE_SAVED_SEARCH,
		customData: id ? { label: String(id) } : undefined,
		name: 'dlr_saved_search_delete_confirmed',
		schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
		version: SNOWPLOW_EVENTS.CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};

export const triggerDeleteSavedSearchLinkClickedEvent = (id?: string | number): void => {
	const eventPayload = getSnowplowEventPayload({
		category: DELETE_SAVED_SEARCH,
		customData: id ? { label: String(id) } : undefined,
		name: 'dlr_saved_search_delete_clicked',
		schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
		version: SNOWPLOW_EVENTS.CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};

export const triggerKeepButtonClickedEvent = (id?: string | number): void => {
	const eventPayload = getSnowplowEventPayload({
		category: DELETE_SAVED_SEARCH,
		customData: id ? { label: String(id) } : undefined,
		name: 'dlr_saved_search_delete_keep_clicked',
		schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
		version: SNOWPLOW_EVENTS.CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
